module.exports = __webpack_public_path__ + "assets/img/fotolia_113943571.41117a91.jpg";